import Button from '@berlitz/button'
import Spacer from '@berlitz/spacer'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { ErrorWrapper } from './style'

interface Prop {
  onRetry: Function
}

const ViewMaterialError: React.FC<Prop> = ({ onRetry }) => {
  return (
    <ErrorWrapper className="error">
      <span>
        <FormattedMessage id="An unknown error has occurred" />.
      </span>
      <Spacer size="xs" />
      <Button small onClick={onRetry}>
        <FormattedMessage id="Click here to retry" />
      </Button>
    </ErrorWrapper>
  )
}

export default ViewMaterialError
